package com.havn.app.core.media

class HavnPhotoPicker(
    private val pickPhoto: ((HavnPickedPhoto?) -> Unit) -> Unit
) {
    fun pick(onResult: (HavnPickedPhoto?) -> Unit) {
        pickPhoto(onResult)
    }

    companion object {
        val Unavailable = HavnPhotoPicker { onResult -> onResult(null) }
    }
}

data class HavnPickedPhoto(
    val fileName: String,
    val bytes: ByteArray,
    val contentType: String,
    val thumbnailDataUrl: String? = null,
    val thumbnailWidth: Int? = null,
    val thumbnailHeight: Int? = null
)
